import { fetcher } from "./fetcher";

interface CreateRoom {
  name: string;
  description?: string;
  roomType: RoomType
  waitRoom: boolean
}

export type RoomStatus = "Created" | "Active" | "Completed" | "Expired" | "AdminLeaved" | "LimitedByTime" | "Suspended"
export type RoomType = "Once" | "Permanent"

export interface RemoteRoom extends CreateRoom {
  id: string;
  leader: string;
  status: RoomStatus;
  expireTime: string
  startCall?: string
  tarif: "FREE" | "PAY"
  endCall?: string
}

export async function createRoom(room: CreateRoom) {
  const res = (await fetcher.post({
    path: "/room/create",
    payload: room,
  })) as RemoteRoom;
  return res;
}

export async function getRoomById(id: string) {
  return (await fetcher.get({
    path: `/room/${id}`,
  })) as RemoteRoom;
}
